import $ from 'jquery';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SimpleAjaxForm from '../../components/simple-ajax-form';
import VeevOneSlider from './components/veev-one-slider';
$(() => {
    RevealWhenVisible.init();
    VeevOneSlider.init();
    SimpleAjaxForm.init();
    ModalVideoWithParameters.init();
});
